import * as types from './_actionTypes';

const initialState = {
  myCourses: [],
  selectedCourseContents: [],
  selectedContent: null,
  statistics: null,
  loading: false,
  contentsLoading: false,
  contentLoading: false,
  error: null,
  success: null
};

const smeContentReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Courses
    case types.FETCH_SME_COURSES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_SME_COURSES_SUCCESS:
      return {
        ...state,
        loading: false,
        myCourses: action.payload,
        error: null
      };
    
    case types.FETCH_SME_COURSES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    // Fetch Course Contents
    case types.FETCH_SME_COURSE_CONTENTS_REQUEST:
      return {
        ...state,
        contentsLoading: true,
        error: null
      };
    
    case types.FETCH_SME_COURSE_CONTENTS_SUCCESS:
      return {
        ...state,
        contentsLoading: false,
        selectedCourseContents: action.payload,
        error: null
      };
    
    case types.FETCH_SME_COURSE_CONTENTS_FAILURE:
      return {
        ...state,
        contentsLoading: false,
        error: action.payload
      };
    
    // Create Content
    case types.CREATE_SME_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    
    case types.CREATE_SME_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCourseContents: [...state.selectedCourseContents, action.payload],
        success: 'Content created successfully',
        error: null
      };
    
    case types.CREATE_SME_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    
    // Update Content
    case types.UPDATE_SME_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null
      };
    
    case types.UPDATE_SME_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCourseContents: state.selectedCourseContents.map(content =>
          content.id === action.payload.id ? action.payload : content
        ),
        success: 'Content updated successfully',
        error: null
      };
    
    case types.UPDATE_SME_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null
      };
    
    // Fetch Single Content by ID
    case types.FETCH_SME_CONTENT_BY_ID_REQUEST:
      return {
        ...state,
        contentLoading: true,
        error: null
      };

    case types.FETCH_SME_CONTENT_BY_ID_SUCCESS:
      return {
        ...state,
        contentLoading: false,
        selectedContent: action.payload,
        error: null
      };

    case types.FETCH_SME_CONTENT_BY_ID_FAILURE:
      return {
        ...state,
        contentLoading: false,
        error: action.payload
      };

    // Delete Content
    case types.DELETE_SME_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.DELETE_SME_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedCourseContents: state.selectedCourseContents.filter(
          content => content.id !== action.payload
        ),
        selectedContent: state.selectedContent?.id === action.payload ? null : state.selectedContent,
        success: 'Content deleted successfully',
        error: null
      };
    
    case types.DELETE_SME_CONTENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    // Fetch Statistics
    case types.FETCH_SME_CONTENT_STATS_REQUEST:
      return {
        ...state,
        error: null
      };
    
    case types.FETCH_SME_CONTENT_STATS_SUCCESS:
      return {
        ...state,
        statistics: action.payload,
        error: null
      };
    
    case types.FETCH_SME_CONTENT_STATS_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    
    // Clear Error
    case types.CLEAR_SME_CONTENT_ERROR:
      return {
        ...state,
        error: null,
        success: null
      };
    
    default:
      return state;
  }
};

export default smeContentReducer;
